export default __webpack_public_path__ + "5c243b3e820c390692ff26ac8442348c.png";